import React from 'react';
import axiosInstance, { base_url } from "../utils/axiosConfig";
import { useDispatch, useSelector } from "react-redux";

const BestSelling = () => {
  const productState = useSelector((state) => state.product.product);

  // Internal styles object for small, compact, modern UI
  const styles = {
    section: {
      padding: '2rem 0',
      backgroundColor: '#f8f9fa',
      fontFamily: "'Inter', sans-serif",
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 1rem',
    },
    title: {
      fontSize: '1.75rem',
      fontWeight: '700',
      color: '#1a1a1a',
      marginBottom: '1.5rem',
      textAlign: 'center',
      position: 'relative',
    },
    titleAfter: {
      content: '""',
      position: 'absolute',
      bottom: '-0.5rem',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '3rem',
      height: '0.25rem',
      backgroundColor: '#ff6b35',
      borderRadius: '0.125rem',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
      gap: '1.5rem',
    },
    card: {
      backgroundColor: '#ffffff',
      borderRadius: '0.75rem',
      overflow: 'hidden',
      boxShadow: '0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 1px 3px -1px rgba(0, 0, 0, 0.06)',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      position: 'relative',
      cursor: 'pointer',
      height: '320px', // Fixed height for compactness
      display: 'flex',
      flexDirection: 'column',
    },
    cardHover: {
      transform: 'translateY(-2px)',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    },
    badge: {
      position: 'absolute',
      top: '0.75rem',
      left: '0.75rem',
      backgroundColor: '#ff6b35',
      color: '#ffffff',
      padding: '0.25rem 0.75rem',
      borderRadius: '0.375rem',
      fontSize: '0.75rem',
      fontWeight: '600',
      zIndex: 10,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
    image: {
      width: '100%',
      height: '180px',
      objectFit: 'cover',
      transition: 'transform 0.3s ease',
    },
    imageHover: {
      transform: 'scale(1.02)',
    },
    content: {
      padding: '1rem',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    productTitle: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#1a1a1a',
      marginBottom: '0.5rem',
      lineHeight: '1.3',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
    },
    price: {
      fontSize: '1.25rem',
      fontWeight: '700',
      color: '#ff6b35',
      margin: '0',
    },
    priceText: {
      fontSize: '0.75rem',
      color: '#6b7280',
      marginBottom: '0.125rem',
      fontWeight: '500',
    },
    noProducts: {
      textAlign: 'center',
      color: '#6b7280',
      fontSize: '1rem',
      padding: '1.5rem',
    },
  };

  return (
    <>
      <section style={styles.section}>
        <div style={styles.container}>
          <h5 style={styles.title}>
            Best Selling Products
            <div style={styles.titleAfter} />
          </h5>
          {productState.length > 0 ? (
            <div style={styles.grid}>
              {productState.slice(0, 4).map((product, index) => (
                <div
                  key={index}
                  className="bestselling-compact-card" // Unique classname
                  style={styles.card}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
                    const img = e.currentTarget.querySelector('.bestselling-compact-image');
                    if (img) img.style.transform = 'scale(1.02)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 1px 3px -1px rgba(0, 0, 0, 0.06)';
                    const img = e.currentTarget.querySelector('.bestselling-compact-image');
                    if (img) img.style.transform = 'scale(1)';
                  }}
                >
                  <div style={styles.badge}>Bestseller</div>
                  <img
                    src={`${base_url}${product.images?.[0]?.url}`}
                    className="bestselling-compact-image" // Unique classname
                    style={styles.image}
                    alt={product.title || "Product"}
                  />
                  <div style={styles.content}>
                    <div>
                      <h5 style={styles.productTitle}>
                        {product.title || "Product Name"}
                      </h5>
                      <p style={styles.priceText}>Start from</p>
                    </div>
                    <p style={styles.price}>
                      Rs.{product.CurrentPrice || "0"}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p style={styles.noProducts}>
              No best-selling products available at the moment.
            </p>
          )}
        </div>
      </section>
    </>
  );
};

export default BestSelling;